export default __webpack_public_path__ + "static/media/wallet-img.de10a405.png";